import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(),
        provideRouter(routes),
        provideClientHydration(),
        // * disabling PWA
        // provideServiceWorker('ngsw-worker.js', {
        //     enabled: !isDevMode(),
        //     registrationStrategy: 'registerWhenStable:30000'
        // }),
        provideAnimationsAsync(),
    ],
};
